import { render, staticRenderFns } from "./MapHistorialSection.vue?vue&type=template&id=c0038fc8&scoped=true&"
import script from "./MapHistorialSection.vue?vue&type=script&lang=js&"
export * from "./MapHistorialSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0038fc8",
  null
  
)

export default component.exports